var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 45.75L7.95 43.5L3.075 41.25L1.5 45.75Z",
    fill: "#F7B600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1756 27.2999L11.1006 18.1499L9.60059 22.3499L20.1756 27.2999Z",
    fill: "#FFDD7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59971 22.3501L7.94971 27.0751L28.0497 36.4501L29.0247 36.1501L20.1747 27.3001L9.59971 22.3501Z",
    fill: "#F7B600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 31.8002L21.375 38.7752L28.05 36.4502L7.95 27.0752L6.375 31.8002Z",
    fill: "#FFDD7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72559 36.5248L14.6256 41.1748L21.3756 38.7748L6.37559 31.7998L4.72559 36.5248Z",
    fill: "#F7B600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72471 36.5249L3.07471 41.2499L7.94971 43.4999L14.6247 41.1749L4.72471 36.5249Z",
    fill: "#FFDD7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.925 23.4001C28.95 28.3501 31.575 33.9001 29.775 35.7001C27.9 37.5001 22.35 34.9501 17.25 29.9251C12.225 24.9751 9.60002 19.4251 11.4 17.6251C13.275 15.8251 18.825 18.4501 23.925 23.4001Z",
    fill: "#493816"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6243 10.875C16.4243 9.15001 17.6993 8.40001 19.3493 8.70001C17.7743 6.82501 18.7493 5.47501 21.2243 6.00001C21.9743 6.15001 20.9243 7.42501 20.2493 7.42501C22.2743 8.92501 21.1493 10.575 18.9743 10.2C20.9243 12.825 17.6243 12.15 16.1243 12.3C15.7493 14.25 17.9993 16.5 17.2493 16.5C15.5993 16.5 12.8993 10.275 17.6243 10.875Z",
    fill: "#42ADE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3753 14.475C32.2503 15 29.1003 10.05 33.0003 9.97499C30.7503 7.94999 31.0503 6.97499 34.0503 6.89999C30.6003 3.44999 36.0753 2.24999 36.6003 4.04999C36.7503 4.57499 34.9503 3.59999 34.3503 4.57499C33.6753 5.69999 38.5503 8.62499 33.5253 8.39999C35.4003 10.275 35.4753 11.175 32.5503 11.475C32.9253 12.075 34.1253 14.175 33.3753 14.475Z",
    fill: "#FF8736"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6494 26.1752L35.7744 25.2002C35.7744 25.2002 36.8244 26.7752 37.5744 27.3752C38.1744 24.6752 38.0244 23.1002 41.0994 24.9002C39.3744 20.2502 42.2244 21.9752 44.9994 23.2502C44.8494 22.0502 44.9994 22.2002 46.1994 21.8252C47.2494 25.8002 44.3994 24.6002 42.1494 23.3252C43.4994 26.9252 42.0744 26.7002 39.2244 25.5002C39.1494 27.0002 38.6994 28.7252 37.7994 28.8752C36.7494 29.1752 34.6494 26.1752 34.6494 26.1752Z",
    fill: "#ED4C5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2494 15.075C24.8994 16.875 22.7244 17.85 21.1494 19.425C19.4994 21.075 18.5244 25.575 18.5244 25.575C18.5244 25.575 19.1244 20.85 20.6994 19.05C22.1244 17.4 24.2244 16.2 25.3494 14.325C27.2994 10.875 25.4994 6.375 22.9494 3.75C23.4744 3.3 24.2244 2.7 24.5994 2.25C27.0744 5.325 29.1744 11.25 26.2494 15.075Z",
    fill: "#C28FEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5747 18.9C26.6247 20.325 25.1997 22.425 23.8497 24.375C22.6497 26.1 18.8247 28.275 18.8247 28.275C18.8247 28.275 22.4247 25.8 23.5497 24C24.8997 21.75 26.2497 19.425 28.3497 17.775C32.5497 14.55 38.6247 14.85 43.3497 16.575C43.0497 17.25 42.5247 18.675 42.5247 18.675C42.5247 18.675 32.5497 15.975 28.5747 18.9Z",
    fill: "#FF8736"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9007 18.5251C35.6257 20.1751 35.0257 22.2001 34.0507 24.0751C33.1507 25.8001 31.9507 27.4501 30.2257 28.3501C28.2757 29.3251 24.0007 29.0251 24.0007 29.0251C24.0007 29.0251 28.2757 28.9501 30.0757 27.7501C31.8757 26.5501 32.8507 24.4501 33.5257 22.5001C34.8757 18.7501 36.5257 14.7001 40.4257 13.0501C40.6507 13.7251 41.1757 15.1501 41.1757 15.1501C41.1757 15.1501 39.0007 15.7501 36.9007 18.5251ZM2.4082 10.7438L4.5292 8.62207L6.65095 10.7431L4.52995 12.8656L2.4082 10.7438Z",
    fill: "#42ADE2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38037 17.3976L7.50062 15.2766L9.62162 17.3976L7.50062 19.5186L5.38037 17.3976Z",
    fill: "#FF8736"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7681 7.36636L12.8891 5.24536L15.0101 7.36636L12.8891 9.48736L10.7681 7.36636Z",
    fill: "#ED4C5C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9038 32.7719L36.0248 30.6501L38.1458 32.7719L36.0248 34.8929L33.9038 32.7719Z",
    fill: "#C28FEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1768 40.0424L31.2978 37.9214L33.4195 40.0431L31.2978 42.1641L29.1768 40.0424Z",
    fill: "#ED4C5C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4595 41.7052L40.5805 39.5835L42.7015 41.7052L40.5805 43.8262L38.4595 41.7052Z",
    fill: "#FF8736"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5581 32.0481L42.6791 29.9271L44.8001 32.0481L42.6791 34.1699L40.5581 32.0481ZM37.0166 9.61711L39.1376 7.49536L41.2594 9.61711L39.1384 11.7381L37.0166 9.61711Z",
    fill: "#42ADE2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2837 22.3441L16.4054 20.2231L18.5264 22.3441L16.4054 24.4659L14.2837 22.3441Z",
    fill: "#ED4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.915157b80002cfda867b3454f639055b.svg";
export { ForwardRef as ReactComponent };